export function getUrlQueryParams(url: string): any {
    const result: any = {};
    const searchParams = new URLSearchParams(url);
    for (const [key, value] of searchParams) {
        result[key] = value;
    }
    return result;
}